import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import {
  IWizItemRenderer,
  WizButton,
  WizDatasource,
  WizEventManager,
  WizGroup,
  WizHgroup,
  WizImage,
  WizLabel,
  WizPopUp,
  WizVgroup
} from '@wizeoo/akm-component-lib';
import { Observable, of } from 'rxjs';
import { AngularEditorComponent, AngularEditorConfig } from '@wfpena/angular-wysiwyg';
import { FIELD_KIND, FormatVO, WizConstants } from '@wizeoo/akm-compute-lib';

import { ViewData } from '../../../../model/view.data';
import { FreedataValueVO } from  '../../../../vo/core/freedatavalue.vo';
import { ConnectVO } from '../../../../vo/core/connect.vo';
import { FreedataArgsVO } from '../../../../vo/core/freedataargs.vo';
import { PivotField } from '../../../../manager/baselines/pivot-field.obj';
import { StyleEngine } from '../../../../manager/workingdata/style.engine';
import { AttachmentService, MediaReference } from '../../../../command/core/attachment/attachment.service';
import { Model } from '../../../../model/model';
import { IFreedataWidget } from '../../../../manager/widgets/i-widget';
import { ArgEditorData } from '../../freedatas/renderers/args.renderer';
import { WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';
import { PopUtils } from '../../../../framework/components/pop/pop-utils';

import { zoomPopParams } from '../../freedatas/renderers/zoom.pop';
import { WIZ_BOOLEAN, WizBooleanUtils } from '@wizeoo/akm-core-lib';
/**
 * rendu des champs disponibles
 */
@Component({
  selector: 'smallargs-renderer',
  templateUrl: './smallargs.renderer.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmallArgsRenderer implements IWizItemRenderer<WidgetConfigurationItemObj, ArgEditorData> {
  constructor(public elementRef: ElementRef, private _cdRef: ChangeDetectorRef) {}
  
  @ViewChild('argContainer') argContainer: WizHgroup; // groupe principal

  @ViewChild('imgGp', { read: WizHgroup, static: false }) imgGp: WizHgroup; // image du FDV
    @ViewChild('imgLbl', { read: WizLabel, static: false }) imgLbl: WizLabel;
    @ViewChild('img', { read: WizImage, static: false }) img: WizImage;
  
  @ViewChild('bt', { read: WizButton, static: false }) bt: WizButton; // fonction connect

  @ViewChild('linkGp', { read: WizHgroup, static: false }) linkGp: WizHgroup; // rendu hyperlink du FDV

  @ViewChild('freeGrp', { read: WizHgroup, static: false }) freeGrp: WizHgroup; // rendu html libre
  @ViewChild('ae') ae: AngularEditorComponent; // bt save
    
  @ViewChild('freeImgGrp', { read: WizHgroup, static: false }) freeImgGrp: WizHgroup; // groupe image libre
    @ViewChild('freeImg') freeImg: WizImage; // image libre

  @ViewChild('workflowGroup', { read: WizVgroup, static: false }) workflowGroup: WizVgroup; // rendu hyperlink du FDV


  /* ##############################################################################
            cycle de vie
  ############################################################################## */

    /**
     * contexte. Attention, non disponible dans la vue Freedata
     */
    public get context(): WidgetConfigurationItemObj {
      return  this.field?.contextItem; //  this.data?.context?.source;
    }


    public get injectClass(): string {
      let myclass: string = 'voidme';
      if(!!this.context?.sty) {
        myclass = this.context?.sty;
      }
      return myclass;
    }

    public compoValue: any = null; // la valeur, polymorphe
  
    //##### les activateurs de ngIf ######

    uselbl = false; // texte

    useCbx = false; // bool


    useimgGp = false;
    usemedia = false;
   
    uselistGP = false; // champs liste de valeurs
  

    uselinkGp = false; // pas de link par défaut...
    public linkUrl: string = ''; // cas d'un rendu link, label|url
    public linkLabel: string = ''; // cas d'un rendu link, label|url

    usebt = false; // fonction connect
    public cnx: ConnectVO = null; // fonction connect du bouton

    usefreeGrp = false; // gestion rendu libre
    
    usefreeImgGrp = false; // image libre
    public imgSrcObs: Observable<string> = null;
    public imgBlobid: string = null;
  
    usecolor = false;

    useworkflow = false; // rendu workflow
    public workImage: Observable<string> = of(null); // image liée
    public workImageBlob: string = null;
    public workIcon: string = null; // l'icone du statut si utilisée
    public workflowLabel: string = null; // le libellé du workflow
    public workFile:  MediaReference = null; // pièce jointe


  /** configuration de l'editeur html */
  public editorConfig: AngularEditorConfig = {
    width: '100%',
    height: '100%',
    editable: false,
    enableToolbar: false,
    showToolbar: false,
    spellcheck: false,
    //imageResizeSensitivity: 0
  }

  owner: null;
  private _data: ArgEditorData;
  @Input() public set data(src: ArgEditorData) {
    if (src === this._data) return;

    this._data = src;
    // only now (ré)alimente l’état
    this.feed();
  }
  public get data(): ArgEditorData {
    return this._data;
  }

  public get model(): Model {
    return Model.getInstance();
  }

  /** accesseur sur le field du WidgetItem, casté */
  public get field(): PivotField {
    const field: PivotField =  this._data?.context?.field as PivotField;
    return field;
  }

  /** accesseur sur le widget, casté */
  public get widget(): IFreedataWidget {
    return this.field?.widget ? this.field?.widget as IFreedataWidget : null;
  }

  /** rendu label custom ou label par défaut */
  public get alternateLabel(): string {
    let result: string = this.data?.arg?.trsLabel;
    if(!!this.field?.contextItem?.lbl) {
      result = this.field.contextItem.lbl;
    }
    return result;
  }

  /** affichage ou pas du libellé */
  public get showLabel() :boolean {
    // console.log('argRenderer showLabel', this._data.context?.showLabel);
    return !this._data.context || this.field?.contextItem?.slbl;
  }


  /** présence d'une image, pour affichage de la poubelle */
  public hasImage(): boolean {
    const valueStr: string = !!this.data.arg ? this.data?.fdv?.trueArgsObj[this.data.arg.code] : null;
    return !!valueStr;
  }

  /** readonly sur les images, pas de poubelle */
  public get readOnly():boolean {
    return this.argContainer?.wizDisabled;
  }

  /** 
   * mise à jour du renderer, sur init / sur modif du gridsterItem
   * prise en compte des FDs de FDs avec champ custom
   */
  public feed(): void {
    if (!this.data || !this.data.fdv) {
      // console.log('maybe fake', this.data);
      return;
    }

    // la valeur de base
    let valueStr: string;
    if (!!this.data.arg) {
      valueStr = this.data.fdv.argsObjVO[this.data.arg.code];
    } else { // de l'html libre, une image ou une action Connect
      valueStr = this.field.contextItem.lbl;
    }  
    this.compoValue = valueStr;

    // console.log('who', this.data.arg.code, this.data.context?.subField);
    if (this.data.arg?.dataType === FIELD_KIND.OBJECT) {
      // const valueStr: string = this.data.fdv.argsObjVO[this.data.arg.code];
      if (!!this.data.arg.datas) { // dropDown     
          // 1er partie, code du FD / CHRONO, 2ème : level, 3ème : champ
          const parts: string[] = this.data.arg.datas.split(ViewData.CONTEXT_SEPARATOR);
          if (parts.length === 2) { // il faut les 2 morceaux, pour affichage en mode drop
            
            if (!!this.data.context?.subField) { // la conf gridster amène un param de plus, le champ sur le FD cible
              // this._customField = this.data.context.subField;
              const subArg: FreedataArgsVO = this.model.freedataEngine.getArgFromFD(parts[0], this.data.context?.subField);
              // console.log('argRenderer 3 parts', subArg, valueStr);

              // collecte du bon FDV
              if (valueStr) {
                const pair = valueStr.split(ViewData.CONTEXT_SEPARATOR);
                const subFDV: FreedataValueVO = this.model.freedataEngine.getFreedataValue(pair[0], pair[1]);
                // console.log('subFD', valueStr, subFDV);
                // si le FDV source a été supprimé
                valueStr = subFDV?.argsObjVO[this.data.context?.subField] || null;
                this.compoValue = valueStr;
              } 
              this.feedSimpleField(subArg, valueStr);                
            } else {
            
              // const fdvs: FreedataValueVO[] = this.model.freedataEngine.getFreedataValuesByLevel(this.data.arg.datas);
              // this.freedataValueDS.setSource(fdvs);
            }
          }  else {
            // console.log('not 2 parts', parts);
            // this.dd.wizDataProvider = null; // this.data.datas;
          }

          // if (!!valueStr) { // une valeur, sélection
          //   const codePart: string[] = valueStr.split(ViewData.CONTEXT_SEPARATOR);
          //   if (codePart.length === 2) {
          //     this.freedataValueDS.select([this.freedataValueDS.getItemByKey(codePart[1])]) ; 
          //   }
          // }
      } else {
        // console.log('no datas', this.data.arg);
      }
    } else {
      this.feedSimpleField(this.data.arg, valueStr);
    }

    setTimeout(() => {
      this._cdRef.markForCheck();
    }, 0);
    
  }

  /** alimentation des champs primitifs */
  private feedSimpleField(arg : FreedataArgsVO, valueStr: string): void {
    
    // interception du contenu libre
    if(!arg) {  
      switch(this.field?.contextItem?.fdvf) {
        case ViewData.FORM_HTML:
          this.usefreeGrp = true;
          //console.log('sargRender', this.ae);
          setTimeout(() => {
            if(this.ae) {  
              //console.log('sargRender 1', this.ae);          
              this.ae.config = this.editorConfig;
              this.ae.placeholder='';
              this.ae.showPlaceholder = false;
              this.ae.writeValue(valueStr);
              //this._cdRef.markForCheck();
            } else { // twice is better
              setTimeout(() => {
                //console.log('sargRender 2', this.ae); 
                this.ae.config = this.editorConfig;
                this.ae.placeholder='';
                this.ae.showPlaceholder = false;
                this.ae.writeValue(valueStr);
                this._cdRef.markForCheck();
              }, 0);
            }
          }, 0);

        break;
        case ViewData.FORM_ACTION:        
          this.cnx = this.model.connectMapExt?.get(this.model.domainCode)?.get(this.model.businessUnitCode)?.get(valueStr);
          this.usebt = true; 
        break;
        case ViewData.FORM_IMAGE:
          if(!!valueStr) {
            this.imgSrcObs = AttachmentService.getInstance().downloadAttachmentForWidget(valueStr, false);
            this.imgBlobid = valueStr;
          } else {
            this.imgSrcObs = of(null);
            this.imgBlobid = null;
          }
          this.usefreeImgGrp = true;
        break;
      }
    } else { // un champ de codif

      let finalType: string = arg.dataType; // pour les formules, le type final peut être différent
      
      if(arg.dataType === FIELD_KIND.FORMULA) { // pour les formules, on prend le type du format (s'il existe)
        finalType = FIELD_KIND.STRING;
        try {
          let result: string = null;
          if(!!arg.valor && arg.valorTrigger?.indexOf(ViewData.TRIGGER_ALWAYS) > -1){
            result = this.model.freedataFormulaCoreEngine.computeFreedataExp(this.data.fdv, arg.valor, null).valor || null;
          }
          if(arg.format) {
            let formatVO = this.model.formatEngine.getFormat(arg.format.split(ViewData.KEY_SEPARATOR)[0], arg.format.split(ViewData.KEY_SEPARATOR)[1]);
            finalType = formatVO.dataKind;
            result = this.model.formatEngine.applyFormat(result, finalType, arg.format, null);
          }
          this.compoValue = result;
          // console.log('formula:', this.compoValue);
          
        } catch(e: any) {
          // console.log('oups formula', arg, this.compoValue);
        }
      }

      switch(finalType) {
        case FIELD_KIND.OBJECT: 
          if (!!arg.datas) { // dropDown
            // 1er partie, code du FD / CHRONO, 2ème : level, 3ème : champ
            const parts: string[] = arg.datas.split(ViewData.CONTEXT_SEPARATOR);
            // if (parts.length === 2) { // il faut les 2 morceaux, pour affichage en mode drop
            //   const fdvs: FreedataValueVO[] = this.model.freedataEngine.getFreedataValuesByLevel(arg.datas);
            //   this.freedataValueDS.setSource(fdvs);
            // } else {
            //   // this.dd.wizDataProvider = null; // this.data.datas;
            // }
            if (!!valueStr) { // une valeur, sélection
              const codePart: string[] = valueStr.split(ViewData.CONTEXT_SEPARATOR);
              if (codePart.length === 2) {
                let item = this.model.freedataEngine.getFreedataValue(codePart[0], codePart[1]); //)this.freedataValueDS.getItemByKey(codePart[1]);
                if(!!item) {
                  this.compoValue = item.trsLabel;
                }
                // this.freedataValueDS.select([this.freedataValueDS.getItemByKey(codePart[1])]) ; 
              }
            }   
            this.uselbl = true;  
          }
          break;
        case FIELD_KIND.WORKFLOW:
          let settings: any = this.data.arg.settings;
          if(!!this.context.pmdexParams) { // override par params
            // console.log('small arg settings', this.context.pmdexParams);
            settings = this.model.widgetEngine.pmdExParams(this.context);
          }
          let strRes: string = this.model.workflowEngine.formatWorkflow(settings, valueStr);   
          // let strRes: string = this.model.workflowEngine.formatWorkflow(this.data.arg.settings, valueStr);
          if(strRes) {
            let objRes: any = JSON.parse(strRes);
            if(!!objRes.image) {
              this.workImageBlob = objRes.image;
              this.workImage = AttachmentService.getInstance().downloadAttachmentForWidget(objRes.image, true);
            } else {
              this.workImage = of(null);
            }
            if(!!objRes.media) {
              this.workFile = objRes.media;
            } else {
              this.workFile = null;
            }
            this.workIcon = objRes.icon || null;
            this.workflowLabel = objRes.keys?.join(" ") || null;
          } else {
            this.workImageBlob = null;
            this.workImage = of(null);
            this.workFile = null;
            this.workIcon = null;
            this.workflowLabel = null;
          }
          this.useworkflow = true;  
        break;          
        case FIELD_KIND.BINARY:
          if(!!valueStr) {
            //console.log('smallArg imgSrcObs', valueStr);
            // this.imgSrcObs = AttachmentService.getInstance().downloadAttachmentForWidget(valueStr, true);
            
            let thumb: boolean = true;
            if(this.imageRatio >= ViewData.THUMB_MAX_SIZE) {
              thumb = false;
            }
            this.imgSrcObs = AttachmentService.getInstance().downloadAttachmentForWidget(valueStr, thumb);
            this.imgBlobid = valueStr;
          } else {
            this.imgSrcObs = of(null);
            this.imgBlobid = null;
          }
          this.useimgGp = true;  
        break;
        case FIELD_KIND.BINARY_MULTI: // image, en fait
          this.useimgMultiGp = true;
          //setTimeout(() => {
            if(!!valueStr) {        
              let parts: string[] = valueStr.split(WizConstants.KEY_SEPARATOR);
              let format: FormatVO = null;
              if(!!this.context?.fmt) {
              let formatSplit = this.context.fmt.split(ViewData.KEY_SEPARATOR);
              format = this.model.formatEngine.getFormat(formatSplit[0], formatSplit[1]);
              if(format?.regExp === '1') {
                this.onlyOneOnMulti = true;
                if(parts.length > 1) {
                  parts = parts.slice(0, 1);
                }
              }
            }
              
            this.blobList = [];// new Map();
            let thumb: boolean = true;
            // console.log(this.context);
            if(this.imageRatio >= 300) {
              thumb = false;
            }

            parts.forEach(s => {
              this.blobList.push([s, AttachmentService.getInstance().downloadAttachmentForWidget(s, thumb)]);
            });
              //console.log('feed medias', valueStr);
            } else {
              this.blobList = null;  
            }
            //setTimeout(() => {
              // besoin de refresh...
              this._cdRef.markForCheck();
            //}, 0);
          //}, 0);

        break;   

        case FIELD_KIND.COLOR: // une couleur
          if(!valueStr) {
            this.compoValue = StyleEngine.STYLE_DEFAULT_WIDGET_BACKGROUND_COLOR;
          } else {
            this.compoValue = valueStr;
          }
          this.usecolor = true;  
        break;
        case FIELD_KIND.LIST:
          // console.log('argRenderer use list', this.data);
          this.uselistGP = true;
          this.compoValue = this.model.listFieldEngine.generateRendererForFDV(this.widget.fakeFei, this.data.fdv, this.data.arg, valueStr, '<br>');
        break;
        case FIELD_KIND.THRESHOLD:
          // console.log('argRenderer use list', this.data);
          this.uselistGP = true;
          this.compoValue = this.model.listFieldEngine.generateThresholdRendererForFDV(this.widget.fakeFei, this.data.fdv, this.data.arg, valueStr, '<br>');

        break;
        case FIELD_KIND.NUMBER:
        case FIELD_KIND.INT: 
        case FIELD_KIND.DATE: 
   
        let formatOverride: string = arg?.format;
        if(!!this.field.contextItem.fmt) {
          formatOverride = this.field.contextItem.fmt;
        }

        let formattedValue: string = this.model.formatEngine.applyFormat(valueStr, finalType, formatOverride, null);
        this.compoValue = formattedValue; // Number(valueStr);
        // console.log('number?', this.compoValue);
        this.uselbl = true; 

        break;
        case FIELD_KIND.BOOLEAN:
          let boo = WizBooleanUtils.stringToBoolean(valueStr); 
          switch (boo) {
            case WIZ_BOOLEAN.TRUE:
              this.compoValue = 'fa-square-check';
              break;
            case WIZ_BOOLEAN.FALSE:
              this.compoValue = 'fa-square';
              break;
            default:
              this.compoValue = 'fa-square';
          }
          this.useCbx = true; 
        break;
        case FIELD_KIND.COMMENT: 
            this.uselbl = true;  
        break;
        case FIELD_KIND.ACTION: 
          this.cnx = this.model.connectMapExt?.get(this.model.domainCode)?.get(this.model.businessUnitCode)?.get(arg.action);
          this.usebt = true; 
        break;
        case FIELD_KIND.STRING: 
          let formatBypass: boolean = false; // rendu autre que le texte  

          if(!!this.field?.contextItem?.fmt) { // patch gestion media et hyperlink
            const twoPart: string = this.field.contextItem.fmt.split(ViewData.KEY_SEPARATOR)[1];
            if(twoPart === 'MEDIA') {
              formatBypass = true;
              this.compoValue = valueStr;
              this.usemedia = true;   
            } else if(twoPart === 'HYPER') {
              formatBypass = true;
              const dataStr: string = valueStr; // la chaine de texte
              const dataParts: string[] = dataStr?.split(ViewData.KEY_SEPARATOR);
              if(!!dataParts) {
                this.linkUrl = dataParts[0];
                this.linkLabel = dataParts.length > 1 ? dataParts[1] : dataParts[0];
              }
              this.uselinkGp = true; 
            }
          } 

          // fin patch gestion media et hyperlink
          if(!formatBypass) {
            this.uselbl= true; 
          }
        

        break;
        default: 
          this.uselbl= true; 
        break;
      }
    }
 
  }

  /** fonction liée au bouton d'action */
  public doArgAction(): void {   
    // console.log('do Act', this.data);

    let cnxCode: string = null;
    if(!!this.data.arg) {
      cnxCode = this.data.arg.action;
    } else { // connect libre
      cnxCode = this.field.contextItem.lbl;
    }

    if(!!cnxCode) {
      this.model.connectEngine.doArgActionExt(cnxCode, this.widget, [this.data.fdv]);
    }
  }
  
  private zoomPop: WizPopUp; // la popUp de zoom sur les images

  /**
   * zoom sur une image
   */
  public seeImage(latency: number, blobid: string): void {
    // console.log('seeImage', latency, blobid, this.compoValue);
    // this.sendMessage('seeImage:' + latency + ", " + blobid +', ' + this.compoValue);
    if(!!blobid && latency >= 400) {
      

      let blobSet: Set<string> = new Set();
      let blobList: string[] = [];   

      // extraction des blobId
      let argCode: string = this.data.arg.code;
      let rawVals: string[];
      
      [...this.data.provider.getWorkedSource()].forEach((fdv: FreedataValueVO) => {
        rawVals = fdv.argsObjVO[argCode]?.split(WizConstants.KEY_SEPARATOR) || null;
        rawVals?.forEach(bid => {
          if(!blobSet.has(bid)) { // pas de doublons
            blobSet.add(bid);
            blobList.push(bid);
          }
        });
      });

      let params: zoomPopParams = {
        zoomPop: this.zoomPop,
        blobid: blobid,
        blobList: blobList
      }

      PopUtils.showZoomPop(params);
    }
  }


  /* ##############################################################################
       gestion multi-images
  ############################################################################## */

    @ViewChild('imgMultiContainer') imgMultiContainer!: WizHgroup; // image du FDV 

    useimgMultiGp = false;

    // public imgMultiSrcObs: Observable<string>[] = [];
    public blobList: [string, Observable<string>][] = [];

    // multi, afficher une seule pour rendu
    public onlyOneOnMulti: boolean = false;


    private _scrollbarSize = 15; // valeur moyenne Windows

    private _goodRatio: number = 30;
    public get imageRatio(): number {
      // let res: number = this.elementRef.nativeElement.offsetHeight -30;
      if(!!this.imgMultiContainer) {
        const el = this.imgMultiContainer.elementRef?.nativeElement;
        this._goodRatio = el.offsetHeight; //  -15;
        if(el.scrollWidth > el.clientWidth && !this.onlyOneOnMulti) {
          this._goodRatio = this._goodRatio - this._scrollbarSize;
          // console.log('imageRatio & scroll', this._goodRatio);
        }         
      } else {
        // prise de la taille requise gridster complet
        this._goodRatio = this.context?.rows*20; //  -15;
      }

      return this._goodRatio;
    }

  /**
   * chargement de la pièce jointe du workflow
   */
  public loadDropWorkFile(): void {
    AttachmentService.getInstance().filedownloadForWidget(this.workFile);
  }

}
